const theme = {
  green: '#97bf0f',
  yellow: '#ffb400',
  gray: '#f1f1f1',
  white: '#ffffff',
  blue: '#10bbb5',
  red: '#f72967',
};

export default theme;
